import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function setUserArchived(userId) {
    let userRef = firebaseRef.ref('/users/' + userId);

	await userRef.update({
		archived: true,
	});
}

export async function setUserUnarchived(userId) {
	let userRef = firebaseRef.ref('/users/' + userId);

	await userRef.update({
		archived: false,
	});
}
